/* eslint-disable camelcase */
/* eslint-disable no-warning-comments */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
import React, {
    useContext, useCallback, useEffect, useState, useRef
} from 'react';
import _ from 'lodash';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { MLQuotePaymentIDsService, LoadSaveService, EmailQuoteService } from 'gw-capability-quoteandbind';
import { MLPortalStorageService, MLBundleService, MLMultiLobsDataHolderService, MLHistoryService } from 'ml-services-common-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { withRouter } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useValidation } from '@xengage/gw-portals-validation-react';
import { CurrencyValue, formatCurrency, useModal } from '@jutro/components';
import { MLProductCodeUtil, MLLocalDateUtil, convertToSentenceCase } from 'ml-portals-util-js';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { MLCustomQuoteRangeSliderComponent } from 'ml-components-common-react';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { DocumentDownloadService } from '@xengage/gw-portals-document-js';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

import PATrackEvent from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PATrackEvent';

import HOTrackEvent from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/HOTrackEvent';
import PUMBTrackEvent from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PUMBTrackEvent';
import QuotePageDriverTablesComponent from '../../../gw-capability-quoteandbind-pa-react/components/QuotePageDriverTablesComponent/QuotePageDriverTablesComponent';

import CreateCustomQuotePopup from './CreateCustomQuotePopup.metadata.json5';
import PaymentPlanPopup from './PaymentPlanPopup.metadata.json5';
import PaymentPlanPopupStyles from './PaymentPlanPopup.module.scss';
import styles from './QuotePage.module.scss';
import messages from './QuotePage.messages';
import metadata from './QuotePage.metadata.json5';
import HOWizardConfig from '../../../gw-capability-quoteandbind-ho-react/config/ho-wizard-config.json5';

import PAWizardConfig from '../../../gw-capability-quoteandbind-pa-react/config/pa-wizard-config.json5';
import PUPWizardConfig from '../../../gw-capability-quoteandbind-pup-react/config/pup-wizard-config.json5';
import PrivacyPolicyComponent from '../../components/PrivacyPolicy/PrivacyPolicyComponent';
import classNames from 'classnames';
import {
    DriverExclusionAgreementPopup,
    DriverExclusionAgreementPopupMessages,
    DriverExclusionAgreementPopupStyles
} from 'ml-capability-quoteandbind-common-react';
import { IntlContext } from '@jutro/legacy/locale';

import { BreakpointTrackerContext } from '@jutro/legacy/layout';

const {
    ML_STORAGE_KEY_PREVIOUS_PREMIUM,
    mlRatingConfigs,
    mlPaymentPlan,
    MLCustomHistoryTypes,
    httpSettings
} = appConfig;

const {
    MLRatingForCheckPayment,
    MLRatingForAnnualPayment,
    MLRatingForMortgageePayment,
    MLRatingForMonthlyPayment
} = mlRatingConfigs;

const {
    MLFourPayAnnualPlanPublicId,
    MLTwoPaySemiAnnualPlanPublicId
} = mlPaymentPlan;

const OFFERING_TAB_ID_STRING = 'offeringTab-';
const PREFILL_STEP = '/prefill';
const TAB_BREAKPOINT = 768;
const TERM_TYPE_HALF_YEAR = 'HalfYear';
const TERM_TYPE_7_DAY = '7Days';
const VEHICLES_STEP = '/vehicles';
const ADD_VEHICLE_ACTION = 'add_vehicle';
const REMOVE_VEHICLE_ACTION = 'remove_vehicle';
const PERSONAL_AUTO = 'PersonalAuto';
const HOP_HOMEOWNERS = 'HOPHomeowners';
const PERSONAL_UMBRELLA = 'PersonalUmbrella';
const stepNames = {
    [PERSONAL_AUTO]: ['paAddtlInfoToBuy'],
    [HOP_HOMEOWNERS]: ['hoAddtlInfoToBuy'],
    [PERSONAL_UMBRELLA]: ['pupAddtlDetails']
};
const CUSTOM_QUOTE = 'Custom Quote';

function QuotePage(props) {
    const modalApi = useModal();
    const {
        wizardData: submissionVM,
        goNext,
        updateWizardData,
        steps,
        jumpTo,
        isSkipping,
        history,
        currentStep,
        changeNextSteps,
        currentStepIndex
    } = props;
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const { CustomQuoteService } = useDependencies('CustomQuoteService');
    const { onValidate } = useValidation('QuotePage');
    const viewModelService = useContext(ViewModelServiceContext);

    const showQuoteStartDate = appConfig.showQuoteStartDateInHeader;
    const quoteData = _.get(submissionVM, 'quoteData.value', {});
    const bindData = _.get(submissionVM, 'bindData.value', {});
    const baseData = _.get(submissionVM, 'baseData.value', {});
    const quoteID = _.get(submissionVM, 'quoteID.value');
    const sessionUUID = _.get(submissionVM, 'sessionUUID.value');
    const lobPathString = _.camelCase(baseData.productName);
    // TODO - Remove Default
    const hoCoveragePartType = _.get(submissionVM, 'lobData.homeowners.coverables.coveragePartType_ML.value', 'hopdwelling');

    const isResumedQuote = useRef(isSkipping); // isSkipping will be updated to false after page renders so assigning it to a ref

    const [initialLoadCompleted, setInitialLoadCompleted] = useState(false);
    const [allQuotes, setAllQuotes] = useState([]);
    const [, setSlottedIndex] = useState(0);
    const [selectedQuoteObj, setSelectedQuoteObj] = useState({});
    const [selectedQuoteIndex, setSelectedQuoteIndex] = useState(0);
    const [termTypeChanged, setTermTypeChanged] = useState(false);
    const isBundle = submissionVM.isBundle_ML.value;
    const [activeTab, setActiveTab] = useState(`${OFFERING_TAB_ID_STRING}${selectedQuoteIndex}offeringsTabs`);


    const [selectedCustomQuote, setSelectedCustomQuote] = useState({});
    const [createdCustomQuotes, setCreatedCustomQuotes] = useState([]);
    const [stickyBar, setStickyBar] = useState({});
    const [isQuoteChanged, setIsQuoteChanged] = useState(false);
    const [isQuoting, setIsQuoting] = useState(false);
    const [actionButtonName, setActionButtonName] = useState('');
    const [, setStaleQuoteBranchCode] = useState(undefined);
    const [quoteCompleteEventCreated, setQuoteCompleteEventCreated] = useState(false);
    const isQnB = _.get(submissionVM, 'baseData.portalCode_ML.value') === "QB"
    const [uwIssues, setUwIssues] = useState(null);
    const QUOTED_SUBMISSIONS_KEY = 'quotedSubmissionNumbers';
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);

    useEffect(() => {
        if (uwIssues) {
            throw uwIssues;
        }
    }, [uwIssues]);

    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();
    const {
        addWarningAlert,
        addErrorAlert,
        addSuccessAlert,
        clearBlockAlerts,
        clearManyBlockAlertsStartsWith
    } = MLNotificationBlockUtil();

    let wizardSteps;
    const productCode = baseData.productCode;
    if (productCode === PERSONAL_AUTO) {
        wizardSteps = PAWizardConfig.steps;
    } else if (productCode === HOP_HOMEOWNERS) {
        wizardSteps = HOWizardConfig.steps;
    } else {
        wizardSteps = PUPWizardConfig.steps;
    }

    const skipQuoteAndProceedToHVQDiscrepanciesCheck = submissionVM.value.isConsumerCompRater()
        && !!MLMultiLobsDataHolderService.getFirstHVQConsumerNonCompletedStep()
        && MLMultiLobsDataHolderService.hasCompletedStep('paHVQConsumerPrefillAndCarfax');
    useEffect(() => {
        // Skip quote page here instead of skipping from AccountSyncPage to display the Wizard bar correctly
        if (skipQuoteAndProceedToHVQDiscrepanciesCheck) {
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'paHVQConsumerDiscrepanciesCheck');
            goNext();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /*
    * Shows only the latest created custom offering
    * If chosen offering is custom offering then return chosen offering
    */
    const findCustomOfferingsToShow = (offeredQuotes) => {
        const customOfferings = offeredQuotes.filter((quote) => quote.isCustom === true);
        // customOfferings = $filter('orderBy')(customOfferings, 'publicID', true);
        const chosenCustomQuote = customOfferings.find((quote) => quote.publicID === bindData.chosenQuote);

        if (customOfferings.length > 0) {
            return chosenCustomQuote ? [chosenCustomQuote] : [customOfferings[0]];
        }
        return customOfferings;
    };

    const isBoundOrBinding = (submission) => {
        return submission && submission.bindData && submission.baseData
            && (submission.baseData.status_ML === 'Bound' || submission.baseData.status_ML === 'Binding');
    };

    const isCustomizableQuote = useCallback((quote) => {
        return quote.isCustom;
    }, []);

    const getOfferingCategory = (quote, index, slottedOfferingIndex) => {
        if (!quote.isCustom && index === slottedOfferingIndex) {
            return 'Recommended';
        }

        if (isCustomizableQuote(quote)) {
            return CUSTOM_QUOTE;
        }

        return index > slottedOfferingIndex
            ? 'More Coverage'
            : 'Less Coverage';
    };

    const initForQuotedData = (_quoteData) => {
        const quoteDataToUse = _quoteData || quoteData;
        let offerings = quoteDataToUse.offeredQuotes.filter((quote) => {
            return quote.isCustom === false;
        });

        let slottedOfferingIndex = offerings.findIndex((q) => q.isSlotted_ML);
        offerings = offerings.filter((quote, quoteIndex) => {
            // QB displays one offering up and one offering down from the recommended offering, plus the custom quote not filtered out from PUP
            return slottedOfferingIndex === -1 || (quoteIndex > slottedOfferingIndex - 2 && quoteIndex < slottedOfferingIndex + 2);
        });

        slottedOfferingIndex = offerings.findIndex((q) => q.isSlotted_ML); // update the index after filtering
        if (slottedOfferingIndex === -1 && offerings.length > 0) {
            slottedOfferingIndex = offerings.length > 1 ? 1 : 0;
            offerings[slottedOfferingIndex].isSlotted_ML = true;
        }

        // currently only one custom quote is allowed, so using findCustomOfferingsToShow
        // if in the future multiple custom quotes is allow then need to change to findCustomOfferingsToShowByBranchCode
        offerings = offerings.concat(findCustomOfferingsToShow(quoteDataToUse.offeredQuotes));

        offerings = _.map(offerings, (offering, idx) => {
            if (offering.branchName) {
                offering.offeringLevel = offering.branchName.substring(offering.branchName.lastIndexOf('(') + 1, offering.branchName.lastIndexOf(')'));
            } else {
                offering.offeringLevel = ' ';
            }

            // in order to avoid IllegalArgumentException, isSubmitAgent should be set as false in Q&B
            offering.isSubmitAgent = false;
            offering.offeringCategory = getOfferingCategory(offering, idx, slottedOfferingIndex);
            offering.showLoading = false;
            offering.hasError = false;

            if (quoteData.paymentQuotes_ML) {
                const currentOffering = quoteDataToUse.paymentQuotes_ML.find((q) => q.offeringPublicID === offering.publicID);
                const paymentQuoteList = _.get(currentOffering, 'paymentQuoteList', []);
                offering.others = paymentQuoteList;
            }

            return offering;
        });

        return offerings;
    };

    const initCustomQuotes = useCallback(() => {
            setAllQuotes(initForQuotedData());
        }, [initForQuotedData]);


    const unfilteredTermTypeList = _.get(submissionVM, 'baseData.termType.aspects.availableValues', []);
    const autoTermTypeList = unfilteredTermTypeList.filter((autoTermType) => {
        return autoTermType.code === 'Annual' || autoTermType.code === 'HalfYear';
    });

    // Policy Types
    const isPersonalAuto = useCallback(() => {
        return MLProductCodeUtil.isPersonalAuto(baseData.productCode);
    }, [baseData.productCode]);

    const isHomeowners = useCallback(() => {
        return MLProductCodeUtil.isHomeOwners(baseData.productCode);
    }, [baseData.productCode]);

    const isHomeownersPolicy = useCallback(() => {
        return isHomeowners() && hoCoveragePartType.code === 'hopdwelling';
    }, [hoCoveragePartType, isHomeowners]);

    const isRentPolicy = useCallback(() => {
        return isHomeowners() && hoCoveragePartType.code === 'hoprental';
    }, [hoCoveragePartType, isHomeowners]);

    const isLandlordCondoPolicy = useCallback(() => {
        return isHomeowners() && hoCoveragePartType.code === 'hop_landlord_condo_ml';
    }, [hoCoveragePartType, isHomeowners]);

    const isLandlordHomePolicy = useCallback(() => {
        return isHomeowners() && hoCoveragePartType.code === 'hop_landlord_home_ml';
    }, [hoCoveragePartType, isHomeowners]);

    const isCondoPolicy = useCallback(() => {
        return isHomeowners() && hoCoveragePartType.code === 'hopcondo';
    }, [hoCoveragePartType, isHomeowners]);

    const isPersonalUmbrellaProduct = useCallback(() => {
        return MLProductCodeUtil.isPersonalUmbrella(baseData.productCode);
    }, [baseData.productCode]);

    const isAK7DayPolicy = useCallback(() => {
        return isPersonalAuto() && baseData.policyAddress.state === 'AK' && baseData.termType === '7Days';
    }, [isPersonalAuto, baseData]);
    // End Policy Types

    // Homeowner functions
    const getReplacementCostMsg = useCallback(() => {
        const replacementCost = _.get(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.replacementCost.value', 0);
        const ercVal = formatCurrency(intl, { value: replacementCost, currency: 'usd', showFractions: false, placeholder: '$0' });
        let msg = '';
        if (isHomeowners() && !isRentPolicy()) {
            msg = translator(messages.hoNonRentReplacementCost, { erc: ercVal });
        } else if (isRentPolicy()) {
            msg = translator(messages.hoRentalReplacementCost, { erc: ercVal });
        }
        return msg;
    }, [intl, isHomeowners, isRentPolicy, submissionVM, translator]);

    const getReplacementCostTooltip = useCallback(() => {
        let msg = '';
        if (isHomeownersPolicy() || isLandlordHomePolicy()) {
            msg = translator(messages.hoHomeTooltip);
        } else if (isCondoPolicy()) {
            msg = translator(messages.hoCondoTooltip);
        } else if (isRentPolicy()) {
            msg = translator(messages.hoRentTooltip);
        }
        return msg;
    }, [isCondoPolicy, isHomeownersPolicy, isLandlordHomePolicy, isRentPolicy, translator]);
    // End Homeowner functions

    const navigateToStep = useCallback((pathToFind, data = {}) => {
        const indexOfStep = _.findIndex(
            steps,
            ({ path }) => path === pathToFind
        );
        if (!_.isEmpty(data)) {
            _.set(submissionVM, 'value.wizardActionDataML', data);
        }
        jumpTo(indexOfStep, data);
    }, [jumpTo, steps, submissionVM]);

    // Scroll Listener
    const handleScrollEvent = useCallback(() => {
        if (_.isUndefined(_.get(stickyBar, 'classList', undefined))) {
            return;
        }
        if (window.pageYOffset >= 600 && (window.pageYOffset + window.innerHeight <= document.body.scrollHeight - 700)) {
            stickyBar.classList.add('show');
        } else {
            stickyBar.classList.remove('show');
        }
    }, [stickyBar]);

    const registerScrollEventListener = useCallback(() => {
        window.addEventListener('scroll', handleScrollEvent);
    }, [handleScrollEvent]);

    const removeScrollEventListener = useCallback(() => {
        window.removeEventListener('scroll', handleScrollEvent);
    }, [handleScrollEvent]);
    // End Scroll Listener

    const isMobile = () => {
        return window.innerWidth <= TAB_BREAKPOINT;
    };

    const getOfferingCoveragesFromBranchCodeAndName = useCallback((branchCode, branchName) => {
        const offerings = _.get(submissionVM, `lobData.${lobPathString}.offerings.value`, []);
        const selectedOffering = offerings.find((o) => o.branchCode === branchCode && o.branchName === branchName);
        return _.get(selectedOffering, 'coverages');
    }, [lobPathString, submissionVM]);

    const getIndexedOfferingCoveragesVM = useCallback((index) => {
        const offerings = _.get(submissionVM, `lobData.${lobPathString}.offerings`, []);
        const selectedOffering = offerings.children.find((o) => o.branchCode.value === allQuotes[index].branchCode);
        return _.get(selectedOffering, 'coverages');
    }, [allQuotes, lobPathString, submissionVM]);

    const setSlottedQuote = useCallback((quoteToSlotted) => {
        allQuotes.forEach((quote, index) => {
            if (quote.publicID === quoteToSlotted.publicID) {
                quote.isSlotted_ML = true;
                setSlottedIndex(index);
            } else {
                quote.isSlotted_ML = false;
            }
        });
    }, [allQuotes, setSlottedIndex]);


    const hasQuotedAllPaymentPlans = useCallback((quote) => {
        if (!quote.others && !quote.hasError) {
            return true;
        }
        const expectedNumberOfCustomQuotes = MLQuotePaymentIDsService.getAvailablePaymentPlanIDs(submissionVM.value).length;
        return !_.isUndefined(quote.others) && quote.others.length === expectedNumberOfCustomQuotes && !quote.hasError;
    }, [submissionVM.value]);

    const isPaymentPlanQuoted = (paymentPlan, paymentPlansQuoted) => {
        return paymentPlansQuoted && paymentPlansQuoted.some((plan) => plan.ratingPaymentMethod_ML === paymentPlan.ratingPaymentMethod_ML
            && plan.ratingPaymentSchedule_ML === paymentPlan.ratingPaymentSchedule_ML);
    };

    const refreshSelectedQuoteObj = useCallback((updatedQuote) => {
        // Clone Deep so dependencies on selectedQuoteObj are firing due to reference being changed
        setSelectedQuoteObj(_.cloneDeep(updatedQuote));
    }, []);

    const quotePaymentPlans = (paymentPlans, createdQuotes, quote, callback) => {
        quote.showLoading = true;
        const paymentPlansToQuote = paymentPlans.filter((paymentPlan) => !isPaymentPlanQuoted(paymentPlan, quote.paymentPlans_ML));
        const quotePromise = CustomQuoteService.requestQuotesForSpecifPaymentPlans(sessionUUID, quote.quoteID, quote.publicID, paymentPlansToQuote);
        quotePromise.then((quotes) => {
            createdQuotes.push(...quotes);
            callback();
        }, (error) => {
            console.error(error);
            quote.hasError = true;
            quote.quoteStatus.isStale = true;
            quote.others = [];
        }
        ).finally(() => {
            quote.showLoading = false;
        });
    };

    const quoteForAllOtherPayments = (chosenQuoteData) => {
        const paymentPlanIDs = MLQuotePaymentIDsService.getAvailablePaymentPlanIDs(submissionVM.value);
        const createdQuotes = [];
        quotePaymentPlans(paymentPlanIDs, createdQuotes, chosenQuoteData, () => {
            chosenQuoteData.showLoading = false;
            chosenQuoteData.others = createdQuotes;
        });
    };

    const quoteForAllOtherPaymentsAndOfferings = useCallback((updatedQuotes) => {
        const paymentPlans = MLQuotePaymentIDsService.getAvailablePaymentPlanIDs(submissionVM.value);
        updatedQuotes.forEach((quote) => {
            quote.showLoading = isQnB ? false : true;
            quote.others = [];
        });
        setAllQuotes(updatedQuotes);
        const quotePromise = CustomQuoteService.requestQuotesForSpecifPaymentPlansAndOfferings(sessionUUID, updatedQuotes, paymentPlans, isPaymentPlanQuoted);
        quotePromise.then((response) => {
            const updatedQuotesCopy = [...updatedQuotes];
            updatedQuotesCopy.forEach((quote) => {
                quote.showLoading = false;
                if (response[quote.publicID]) {
                    quote.others = response[quote.publicID];
                }
            });
            setAllQuotes(updatedQuotesCopy);
            if (!quoteCompleteEventCreated) {
                const request = {
                    jobNumber: submissionVM.quoteID.value,
                    sessionUUID: submissionVM.sessionUUID.value,
                    eventType: MLCustomHistoryTypes.QuoteCompleted
                };
                const createHistoryPromise = MLHistoryService.createHistoryEvents([request]);
                createHistoryPromise.then(() => {
                    setQuoteCompleteEventCreated(true);
                });
            }
        }, (error) => {
            // eslint-disable-next-line no-console
            console.error(error);
            const allQuotesCopy = [...allQuotes];
            allQuotesCopy.forEach((quote) => {
                quote.showLoading = false;
                quote.hasError = true;
                quote.others = [];
            });
            setAllQuotes(allQuotesCopy);
            if (!isQnB) {
                throw error;
            }
            return false;
        }).finally(() => {
            // $scope.$broadcast('$quotePaymentPlansComplete');
        });
    }, [CustomQuoteService, allQuotes, sessionUUID, submissionVM.value]);

    /**
     * If the user switches to a different offering we need to pull the payment plans for that offering.
     * In order to take advantage of the parallel quoting capabilities we actually quote all other payment plans
     * for all offerings
     */
    const quoteOtherPaymentsIfNotPresent = useCallback((selectedQuote, updatedQuotes) => {
        const arePaymentQuotesInProgress = updatedQuotes.some((aQuote) => aQuote.showLoading === true);
        if (!hasQuotedAllPaymentPlans(selectedQuote) && !arePaymentQuotesInProgress && !isAK7DayPolicy()) {
            quoteForAllOtherPaymentsAndOfferings(updatedQuotes);
        } else {
            // This needs to be delayed so the scope on the quote summary bar is ready to listen on this broadcast
            // ctrl._withTimeoutPromise(() => {
            //     $scope.$broadcast('$quotePaymentPlansComplete', $scope.selectedQuote.publicID);
            // });
        }
    }, [hasQuotedAllPaymentPlans, isAK7DayPolicy, quoteForAllOtherPaymentsAndOfferings]);

    const setSelectedQuote = useCallback((quote, updatedQuotes = allQuotes) => {
        if (quote === selectedQuoteObj) {
            return;
        }

        setSelectedQuoteObj(quote);
        quote.isSelected = true;
        _.set(submissionVM, 'bindData.value.chosenQuote', quote.publicID);
        updateWizardData(submissionVM);
        setStickyBar(document.getElementById('stickyFooter'));
        quoteOtherPaymentsIfNotPresent(quote, updatedQuotes);
    }, [allQuotes, quoteOtherPaymentsIfNotPresent, selectedQuoteObj, submissionVM, updateWizardData]);

    const setSelectedQuoteAndUpdateTabs = useCallback((quote, quotes = allQuotes) => {
        const tabIndex = quotes.findIndex((q) => q.publicID === quote.publicID)

        setSelectedQuote(quote, quotes);
        setSelectedQuoteIndex(tabIndex);
        setActiveTab(`${OFFERING_TAB_ID_STRING}${tabIndex}offeringsTabs`);
    }, [allQuotes, setSelectedQuote])

    const onQuoteTabChange = useCallback((tabId) => {
        const indexOfNumber = tabId.indexOf('-') + 1;
        const tabSuffix = tabId.substring(indexOfNumber);
        const tabIndex = Number(tabSuffix[0])
        const quote = allQuotes[tabIndex];

        // do no updates if selecting active tab
        if (quote === selectedQuoteObj) {
            return;
        }

        setSelectedQuoteAndUpdateTabs(quote)
    }, [allQuotes, selectedQuoteObj, setSelectedQuoteAndUpdateTabs]);

    const formatAmountString = useCallback((quote) => {
        const premium = _.get(quote, 'premium.monthlyPremium', 0);
        try {
            return intl.formatNumber(premium.amount, { style: 'currency', currency: premium.currency });
        } catch (e) {
            return '';
        }
    }, [intl]);

    useEffect(() => {
        if (isQnB && submissionVM.value.isQuoted()) {
            const quoteNumber = submissionVM?.quoteID?.value || submissionVM?.value?.quoteID;
            storeQuotedSubmissionNumber(quoteNumber);
        }
    }, []);

    const storeQuotedSubmissionNumber = (quoteNumber) => {
        try {
            let list = JSON.parse(localStorage.getItem(QUOTED_SUBMISSIONS_KEY)) || [];

            if (quoteNumber && !list.includes(quoteNumber)) {
                list = [...list, quoteNumber];
                localStorage.setItem(QUOTED_SUBMISSIONS_KEY, JSON.stringify(list));
            }

            return list;
        } catch (e) {
            return [];
        }
    };

    const getPerTermLabel = useCallback((selectedTermType) => {
        let label = isQnB ? translator(messages.non7DaysMonthlyPremium) : translator(messages.perTermAnnual);
        if (selectedTermType === TERM_TYPE_HALF_YEAR) {
            label = isQnB ? translator(messages.non7DaysMonthlyPremium) : translator(messages.perTerm6Month);
        } else if (selectedTermType === TERM_TYPE_7_DAY) {
            label = isQnB ? translator(messages.non7DaysMonthlyPremium) : translator(messages.perTerm7day);
        }
        return label;
    }, [translator]);

    const getQuoteDropdownAvailableValues = useCallback(() => {
        return allQuotes.map((q, index) => {
            return {
                code: index,
                name: `${q.branchName.toUpperCase()} ${formatAmountString(q)}${getPerTermLabel(q.termType_ML)}`
            };
        });
    }, [allQuotes, formatAmountString, getPerTermLabel]);

    const onQuoteDropdownChange = useCallback((quoteIndex) => {
        const quote = allQuotes[`${quoteIndex}`]
        setSelectedQuoteAndUpdateTabs(quote)

    }, [allQuotes, setSelectedQuoteAndUpdateTabs]);

    const skipOnResumeIf = useCallback(() => {
        if (!!_.get(submissionVM, 'bindData.policyNumber.value') && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
            return true;
        }

        if (submissionVM.isBundle_ML.value && (MLBundleService.isJobForPostQuote(submissionVM.quoteID.value) || MLBundleService.isJobPostQuoteStarted(submissionVM.quoteID.value) || MLBundleService.isJobPostQuoteComplete(submissionVM.quoteID.value))) {
            // upon resuming quote from bundle submission, filter out hvq steps from remaining steps
            let nextSteps = steps.slice(currentStepIndex + 1, steps.length);
            const hvqSteps = ['/pa-hvq-steps', '/pa-hvq-consumer-discrepancies', '/pa-hvq-additional-drivers', '/pa-hvq-driver-details', '/pa-hvq-vehicle-details', '/pa-hvq-additional-information', '/hvq-additional-information-prebind']
            nextSteps = nextSteps.filter((step) => {
                return !hvqSteps.includes(step.path)
            });
            changeNextSteps(nextSteps);

            return true;
        }

        return false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // Its possible to land on quote page in draft status from skipOnResume. 
    // If this is the case need quote on first init - similar to generateQuote step in resume flow config v9
    useEffect(() => {
        if (!isSkipping && !skipQuoteAndProceedToHVQDiscrepanciesCheck) {
            const isDraft = baseData.status_ML === 'Draft';
            if ((isResumedQuote.current || isDraft) && !(submissionVM.value.isQuoted() && isAK7DayPolicy())) {
                const quotePromise = LoadSaveService.saveAndQuoteSubmission(submissionVM.value);
                showProgressDialog(messages.calculatingQuote, quotePromise);
                quotePromise.then((res) => {
                    submissionVM.value = res;
                    setAllQuotes(initForQuotedData(res.quoteData));
                    setInitialLoadCompleted(true);
                })
            } else {
                setAllQuotes(initForQuotedData());
                setInitialLoadCompleted(true);
            }

            if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                HOTrackEvent('Quote Step Reached', isSkipping, submissionVM, null, { step: 'Quote Page' }, true);
            } else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                PUMBTrackEvent('Quote Step Reached', isSkipping, submissionVM, null, { step: 'Quote Page' }, true);
            } else {
                PATrackEvent('Quote Step Reached', isSkipping, submissionVM, null, { step: 'Quote Page' }, true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSkipping]);

    useEffect(() => {
        if (initialLoadCompleted) {
            if (_.isEmpty(allQuotes)) {
                return;
            }
            if (allQuotes.length === 1) {
                setSlottedQuote(allQuotes[0]);
            }

            const offerings = _.get(submissionVM, 'quoteData.offeredQuotes.value');
            const draftOffers = _.filter(offerings, ['status', 'Draft']);
            const draftBranchCodes = _.map(draftOffers, 'branchCode');
            setStaleQuoteBranchCode(draftBranchCodes);

            const fallbackQuote = allQuotes[0]
            const slottedQuote = allQuotes.find((quote) => quote.isSlotted_ML === true);
            const landingQuote = allQuotes.find((quote) => bindData?.chosenQuote === quote.publicID)

            setSelectedQuoteAndUpdateTabs(landingQuote || slottedQuote || fallbackQuote)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialLoadCompleted]);

    useEffect(() => {
        const validationErrors = selectedQuoteObj.validationErrors_ML;
        clearManyBlockAlertsStartsWith('validation-');
        if (validationErrors) {
            validationErrors.forEach((error, index) => {
                const errormessage = error.split(': ')[1];
                const alertName = `validation-${index}`;
                if (errormessage && !_.isEmpty(errormessage)) {
                    addErrorAlert(errormessage, alertName);
                } else {
                    addErrorAlert(error, alertName);
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedQuoteObj])

    const isQuotePaymentMortgagee = (quote) => {
        return quote.ratingPaymentMethod_ML === MLRatingForMortgageePayment.ratingPaymentMethod_ML
            && quote.ratingPaymentSchedule_ML === MLRatingForMortgageePayment.ratingPaymentSchedule_ML;
    };

    const isQuotePaymentFull = (quote) => {
        return quote.ratingPaymentMethod_ML === MLRatingForAnnualPayment.ratingPaymentMethod_ML
            && quote.ratingPaymentSchedule_ML === MLRatingForAnnualPayment.ratingPaymentSchedule_ML;
    };

    const isQuotePaymentCheck = (quote) => {
        return quote.ratingPaymentMethod_ML === MLRatingForCheckPayment.ratingPaymentMethod_ML
            && quote.ratingPaymentSchedule_ML === MLRatingForCheckPayment.ratingPaymentSchedule_ML;
    };

    const isQuotePaymentMonthly = (quote) => {
        return quote.ratingPaymentMethod_ML === MLRatingForMonthlyPayment.ratingPaymentMethod_ML
            && quote.ratingPaymentSchedule_ML === MLRatingForMonthlyPayment.ratingPaymentSchedule_ML;
    };

    const isQuoteTermAnnual = (quote) => {
        return quote.premium.termMonths === 12;
    };

    const getCheckPaymentPlanForSelection = useCallback((selectedQuote) => {
        return CustomQuoteService.requestQuotesForSpecifPaymentPlans(sessionUUID, selectedQuote.quoteID, selectedQuote.publicID, [MLRatingForCheckPayment]);
    }, [CustomQuoteService, sessionUUID]);

    const getMaxAmountAmongCustomQuotes = (quote) => {
        if (!quote || !quote.others) {
            return 0;
        }
        return Math.max(...quote.others.map((customQuote) => _.get(customQuote, 'premium.total.amount', 0)));
    };

    const getPaymentName = useCallback((quote) => {
        let name = '';
        if (isQuotePaymentFull(quote)) {
            name = translator(messages.payInFull);
        } else if (isQuotePaymentMortgagee(quote)) {
            name = translator(messages.payByMortgagee);
        } else if (isQuotePaymentMonthly(quote)) {
            name = translator(messages.payByRecurringAutomaticPayment);
        } else if (isQuotePaymentCheck(quote)) {
            name = translator(messages.payByCheck);
        } else {
            console.error(new Error('Could not retrieve payment name for payment instrument'));
        }
        return name;
    }, [translator]);

    const getPaymentSavedAmount = (maxAmount, quote) => {
        const savedAmount = Object.assign({}, quote.premium.total);
        savedAmount.amount = maxAmount - savedAmount.amount;
        return savedAmount;
    };

    const getSingleCheckPaymentAmount = useCallback((quote) => {
        const billingId = isQuoteTermAnnual(quote) ? MLFourPayAnnualPlanPublicId : MLTwoPaySemiAnnualPlanPublicId;
        const paymentPlan = quote.paymentPlans_ML.find((p) => p.billingId === billingId);
        return _.get(paymentPlan, 'installment', { currency: 'usd', amount: 0 });
    }, []);

    const confirmSendEmail = useCallback(() => {
        const sessionInfo = {
            quoteID: quoteID,
            sessionID: sessionUUID,
            emailAddress1: bindData.contactEmail,
            sendType_ML: 'email',
            completedQuote_ML: true,
            productCode_ML: baseData.productCode
        };

        const emailPromise = EmailQuoteService.emailQuote(sessionInfo, isBundle);
        showProgressDialog(platformMessages.emailingQuote, emailPromise);

        emailPromise.then(() => {
            if (submissionVM.bindData.chosenQuote.value !== selectedQuoteObj.publicID) {
                _.set(submissionVM, 'bindData.chosenQuote.value', selectedQuoteObj.publicID);
            }
            if (submissionVM && submissionVM.quoteID && !isBoundOrBinding(submissionVM)) {
                // MLResponsysService.sendDataToResponsysSync(submissionVM.quoteID.value);
            }

            const componentProps = {
                title: translator(messages.thankYou),
                subtitle: translator(messages.emailQuoteSent, { emailAddress: sessionInfo.emailAddress1 }),
                uiProps: {},
                actionBtnLabel: messages.continue,
                onSaveAction: () => {
                    return true;
                }
            };

            modalApi.showModal(
                <FormModalPopover {...componentProps} />
            );
        }, () => {
            console.error(new Error('Quote email unsuccessfully sent.'));
        });
    }, [baseData.productCode, bindData.contactEmail, isBundle, quoteID, selectedQuoteObj.publicID, sessionUUID, showProgressDialog, submissionVM, translator]);

    const showEmailPopup = useCallback((displayableQuotes) => {
        const onSaveAction = () => {
            confirmSendEmail();
            return true;
        };

        const generatePaymentOverrides = () => {
            const maxAmount = getMaxAmountAmongCustomQuotes(selectedQuoteObj);
            const paymentOverrides = displayableQuotes.map((quote, index) => {
                const singleCheckPaymentAmount = isQuotePaymentCheck(quote) ? getSingleCheckPaymentAmount(quote) : {};
                const paymentSavedAmount = getPaymentSavedAmount(maxAmount, quote) ? getPaymentSavedAmount(maxAmount, quote) : {};
                return {
                    [`chosenQuoteLabel${index}`]: {
                        content: getPaymentName(quote)
                    },
                    [`chosenQuoteRadio${index}`]: {
                        path: 'chosenQuote.value',
                        availableValues: [{
                            id: quote.publicID,
                            displayName: ''
                        }],
                    },
                    [`quotePaymentMonthly${index}`]: {
                        visible: isQuotePaymentMonthly(quote),
                        tag: 'div',
                        currency: quote.premium.monthlyPremium.currency,
                        value: quote.premium.monthlyPremium.amount,
                        suffix: `${translator(messages.perMonth)}`
                    },
                    [`quotePaymentCheck${index}`]: {
                        visible: isQuotePaymentCheck(quote),
                        tag: 'div',
                        currency: singleCheckPaymentAmount.currency,
                        value: singleCheckPaymentAmount.value,
                        prefix: `${translator(isQuoteTermAnnual(quote) ? messages.fourPaymentsOf : messages.twoPaymentsOf)} `
                    },
                    [`totalPremium${index}`]: {
                        tag: 'div',
                        currency: quote.premium.total.currency,
                        value: quote.premium.total.amount,
                        prefix: `${translator(messages.totalPremium)} `
                    },
                    [`paymentSavedAmount${index}`]: {
                        visible: paymentSavedAmount.amount > 0,
                        tag: 'div',
                        currency: paymentSavedAmount.currency,
                        value: paymentSavedAmount.amount,
                        prefix: `${translator(messages.save)} `,
                        className: 'font-weight-bold'
                    },
                }
            });

            return Object.assign({}, ...paymentOverrides);
        }

        const overrides = {
            availableQuotesIterable: {
                data: displayableQuotes
            },
            ...generatePaymentOverrides()
        };

        const componentProps = {
            title: translator(messages.oneFinalQuestion),
            uiProps: PaymentPlanPopup.pageContent,
            viewModel: submissionVM.bindData,
            actionBtnLabel: messages.continue,
            overrideProps: overrides,
            modalBodyStyles: PaymentPlanPopupStyles,
            onSaveAction: onSaveAction,
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }, [confirmSendEmail, getPaymentName, getSingleCheckPaymentAmount, selectedQuoteObj, submissionVM.bindData, translator]);

        const downloadDocument = useCallback((url, doc) => {
            const httpPromise = fetch(url);

            showProgressDialog(platformMessages.downloadingDocument, httpPromise);
            httpPromise.then((response) => {
                if (response.ok) {
                    response.blob().then((blob) => {
                        const filename = `${doc.description}.pdf`;

                        if (window.navigator.msSaveOrOpenBlob) {
                            navigator.msSaveBlob(blob, filename);
                        } else {
                            const downloadLink = document.createElement('a');

                            downloadLink.setAttribute('href', window.URL.createObjectURL(blob));
                            downloadLink.setAttribute('download', filename);
                            downloadLink.style.display = 'none';
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            downloadLink.remove();
                        }
                    });
                } else {
                    showErrorModal(platformMessages.error, platformMessages.unableToDownloadDocument);
                }
            });
            httpPromise.catch((error) => {
                console.error(error);
                showErrorModal(platformMessages.error, platformMessages.unableToDownloadDocument);
            });
        }, [showErrorModal, showProgressDialog]);

     const printQuote = useCallback((quoteId, isBundled) => {
            // EventHub.publish('wizard', 'print');
            const periodID = selectedQuoteObj.publicID;
            const createProposalPromise = LoadSaveService.createQuoteProposal(quoteId.value, periodID, isBundled);
    
            // const displayErrorModal = () => showErrorModal(platformMessages.error, platformMessages.unableToDownloadDocument);
    
            showProgressDialog(platformMessages.generatingQuoteProposal, createProposalPromise);
            createProposalPromise.then((data) => {
                const docUid = data.docUID;
                const sessionId = data.sessionID;
                const publicId = data.publicID;

                if (docUid) {
                    const resp = LoadSaveService.downloadDocument(publicId, sessionId);
                    showProgressDialog(platformMessages.downloadingDocument, resp);
                    resp.catch((error) => {
                    console.error(error);
                    showErrorModal(platformMessages.error, platformMessages.unableToDownloadDocument);
                });
                } else {
                    showErrorModal(messages.error, messages.proposalError);
                }
            });
        }, [ selectedQuoteObj, showErrorModal, showProgressDialog]);

    const createProposalForAgentType = (quoteId, isBundled) => {
        printQuote(quoteId, isBundled);
    };

    const handlePrint = () => {
        const isBundled = false;

        createProposalForAgentType(submissionVM.quoteID, isBundled, submissionVM.sessionUUID.value);
    };


    // const handlePrint = useCallback(() => {
    //     window.print();
    // }, []);

    const handleEmail = useCallback(() => {
        const displayableQuotes = selectedQuoteObj.others;

        if (!displayableQuotes.some((q) => isQuotePaymentCheck(q)) && baseData.policyAddress.state === 'NJ') {
            const promise = getCheckPaymentPlanForSelection(selectedQuoteObj);
            showProgressDialog(platformMessages.creatingCustomQuotes, promise);
            promise.then((createdQuotes) => {
                displayableQuotes.push(...createdQuotes);
                setSelectedQuoteObj((prevState) => {
                    return {
                        ...prevState,
                        others: displayableQuotes
                    }
                });
                showEmailPopup(displayableQuotes);
            });
        } else {
            showEmailPopup(displayableQuotes);
        }
    }, [baseData.policyAddress.state, getCheckPaymentPlanForSelection, selectedQuoteObj, showEmailPopup, showProgressDialog]);

    const getTabHeader = useCallback((quote) => {
        return (
            <div>
                <h1 className={styles.tabTitle}>
                    {quote.branchName.toUpperCase()}
                </h1>
                <h2 className={styles.tabPremium}>
                    <CurrencyValue
                        currency="usd"
                        currencyDisplay="symbol"
                        id="premiumField"
                        showFractions
                        tag="span"
                        showGrouping
                        value={_.get(quote, 'premium.monthlyPremium.amount', 0)}
                    />
                    <span className={styles.premiumPerMonth}>
                        {translator(messages.perMonth)}
                    </span>
                </h2>
                {!!quote.showLoading && <div>
                    <img src="/throbber.gif" alt="Loading" />
                </div>}
            </div>
        );
    }, [translator]);

    const getQuoteVm = useCallback((quote) => {
        return viewModelService.create(
            quote,
            'pc',
            'edge.capabilities.policyjob.quoting.dto.OfferedQuoteDTO'
        );
    }, [viewModelService]);

    const getCoveragesForQuoteIfNotPresent = useCallback((quote) => {
        return new Promise((resolve) => {
            if (quote.loadingCoverages) {
                resolve();
            }
            quote.loadingCoverages = true;
            const customQuoteDTO = {
                sessionUUID: sessionUUID,
                quoteID: quoteID,
                quoteBaseVersion_ML: quote.publicID,
                customizableQuote_ML: false
            };
            quote.coveragePromise = CustomQuoteService.getCoverageLobsForOffering(customQuoteDTO)
                .then((covs) => {
                    const lobCovs = _.get(covs, `${lobPathString}`, []);
                    const offerings = _.get(submissionVM, `lobData.${lobPathString}.offerings.value`, []);
                    const selectedOfferingIndex = offerings.findIndex((o) => o.branchName === CUSTOM_QUOTE);

                    const newOffering = {
                        branchCode: quote.branchCode,
                        branchName: quote.branchName,
                        branchPublicID: quote.publicID,
                        coverages: lobCovs
                    };
                    if (selectedOfferingIndex !== -1) {
                        _.set(submissionVM, `lobData.${lobPathString}.offerings.value[${selectedOfferingIndex}]`, newOffering);
                    } else {
                        const offeringsCopy = [...offerings];
                        offeringsCopy.push(newOffering);
                        _.set(submissionVM, `lobData.${lobPathString}.offerings.value`, offeringsCopy);
                    }

                    updateWizardData(submissionVM);
                })
                .finally(() => {
                    quote.loadingCoverages = false;
                    resolve();
                });
        });
    }, [CustomQuoteService, lobPathString, quoteID, sessionUUID, submissionVM, updateWizardData]);

    const isFullPayPlan = useCallback((paymentPlan) => {
        return (paymentPlan.ratingPaymentMethod_ML === 'credit_debit_card' || paymentPlan.ratingPaymentMethod_ML === 'bank_account'
            || paymentPlan.ratingPaymentMethod_ML === 'check') && paymentPlan.ratingPaymentSchedule_ML === 'full_pay';
    }, []);

    const getFullPayPlanForOffering = useCallback((offering) => {
        let fullPayPlan;
        const others = _.get(offering, 'value.others', []);
        if (others.length > 0) {
            fullPayPlan = others.find((paymentPlan) => {
                return isFullPayPlan(paymentPlan);
            });
        } else {
            fullPayPlan = quoteData.offeredQuotes.find((paymentPlan) => {
                return isFullPayPlan(paymentPlan);
            });
        }
        return fullPayPlan;
    }, [isFullPayPlan, quoteData]);

    const getRecurringPlanPeriod = useCallback((chosenQuoteData) => {
        if (chosenQuoteData) {
            if (chosenQuoteData.ratingPaymentSchedule_ML === MLRatingForMonthlyPayment.ratingPaymentSchedule_ML) {
                return chosenQuoteData;
            }
            if (chosenQuoteData.others && chosenQuoteData.others.length > 0) {
                return chosenQuoteData.others.find((quote) => {
                    return quote.ratingPaymentMethod_ML === chosenQuoteData.ratingPaymentMethod_ML
                        && quote.ratingPaymentSchedule_ML === MLRatingForMonthlyPayment.ratingPaymentSchedule_ML;
                });
            }
        }
        return chosenQuoteData;
    }, []);

    const formatBranchName = useCallback((branchName) => {
        if (branchName === CUSTOM_QUOTE || isPersonalUmbrellaProduct()) {
            return branchName;
        }
        if (branchName.lastIndexOf('(') !== -1) {
            return branchName.substring(0, branchName.lastIndexOf('(') - 1);
        }
        if (isQnB && branchName.startsWith("GrandProtect")) {
            return branchName.substring(0, branchName.length - 1);
        }
        return branchName;
    }, [isPersonalUmbrellaProduct, translator]);

    const getOfferingMessage = useCallback((branchName, branchCode) => {
        const formattedBranchName = formatBranchName(branchName);
        if (formattedBranchName === CUSTOM_QUOTE) {
            return translator(messages.aboutCustomCoverage);
        }

        if (isPersonalUmbrellaProduct()) {
            let amountInMillions;
            try {
                const covs = getOfferingCoveragesFromBranchCodeAndName(branchCode, branchName);
                const primaryLiabilityCoverages = covs.primaryCoverages.filter((pc) => pc.code_ML === 'PUPLiability_ML');
                // eslint-disable-next-line radix
                const chosenLiabilityLimit = parseInt(primaryLiabilityCoverages[0].terms[0].chosenTermValue.replace(/\$/g, '').replace(/,/g, ''));
                amountInMillions = chosenLiabilityLimit / 1000000;
            } catch (e) {
                amountInMillions = '';
            }
            return translator(messages.aboutUmbrellaCoverage, { amount: amountInMillions });
        }

        // Landlord coverage is only enhanced so the one message is shown/
        if (hoCoveragePartType.code === 'hop_landlord_home_ml' || hoCoveragePartType.code === 'hop_landlord_condo_ml') {
            return translator(messages.aboutLandlordCoverage);
        }

        const startOfId = 'ml.quoteandbind.quote.';
        const productType = hoCoveragePartType.code !== undefined ? hoCoveragePartType.code : 'pa';
        const messageId = startOfId.concat(productType, '.', formattedBranchName.replace(' ', ''));

        return translator(_.find(messages, { id: messageId }));

    }, [formatBranchName, getOfferingCoveragesFromBranchCodeAndName, hoCoveragePartType.code, isPersonalUmbrellaProduct, translator]);

    // TODO Update to correct FAQ section when completed
    // Link disabled due to business request. Might come back in the future.
    const handleComparePlans = useCallback(() => {
        const faqPath = 'quote-and-buy/faq#compare-auto-info';
        let url = `${window.location.origin}/${faqPath}`;
        if (isHomeowners()) {
            if (isRentPolicy()) {
                url = 'https://www.metlife.com/auto-and-home-tables/renters';
            } else if (isCondoPolicy()) {
                url = 'https://www.metlife.com/auto-and-home-tables/condo';
            } else if (isLandlordCondoPolicy()) {
                url = 'https://www.metlife.com/auto-and-home-tables/landlord-condo';
            } else if (isLandlordHomePolicy()) {
                url = 'https://www.metlife.com/auto-and-home-tables/landlord-home';
            } else {
                url = 'https://www.metlife.com/auto-and-home-tables/homeowners';
            }
        }
        window.open(url, '_blank');
    }, [isCondoPolicy, isHomeowners, isLandlordCondoPolicy, isLandlordHomePolicy, isRentPolicy]);

    const onUpdateEffDate = useCallback(async (updatedQuoteWithDate) => {
        _.set(updatedQuoteWithDate, 'quoteStatus.isStale', true);
        _.set(updatedQuoteWithDate, 'quoteStatus.showLoading', true);
        _.set(updatedQuoteWithDate, 'showLoading', true);

        const coverages = {
            [`${lobPathString}`]: getOfferingCoveragesFromBranchCodeAndName(updatedQuoteWithDate.branchCode, updatedQuoteWithDate.branchName)
        };
        const customQuoteDTO = {
            quote: updatedQuoteWithDate,
            sessionUUID,
            quoteID,
            productCode_ML: _.get(submissionVM, 'baseData.productCode.value'),
            markAsSelectedVersion_ML: updatedQuoteWithDate.isSelected,
            isSubmitAgent: false,
            coverages
        };

        try {
            const quote = await CustomQuoteService.updateCustomQuoteCoverages(customQuoteDTO);
            const offerings = _.get(submissionVM, `lobData.${lobPathString}.offerings.value`, []);
            const selectedOfferingIndex = offerings.findIndex((o) => o.branchCode === quote.branchCode && o.branchName === quote.branchName);
            _.set(submissionVM, `lobs.${lobPathString}.value[${selectedOfferingIndex}].coverages`, quote.coverages);
            updateWizardData(submissionVM);
        } catch (error) {
            showErrorModal(messages.customQuoteErrTitle, messages.customQuoteErrDesc);
        } finally {
            _.set(updatedQuoteWithDate, 'quoteStatus.isStale', true);
            _.set(updatedQuoteWithDate, 'quoteStatus.showLoading', false);
            _.set(updatedQuoteWithDate, 'showLoading', false);

            const allQuotesCopy = [...allQuotes];
            const updatedQuoteIndex = allQuotes.findIndex((o) => o.branchCode === updatedQuoteWithDate.branchCode && o.branchName === updatedQuoteWithDate.branchName);
            allQuotesCopy[updatedQuoteIndex] = updatedQuoteWithDate;
            setAllQuotes(allQuotesCopy);
            setSelectedQuoteObj(updatedQuoteWithDate);
        };
    }, [CustomQuoteService, allQuotes, getOfferingCoveragesFromBranchCodeAndName, lobPathString, quoteID, sessionUUID, submissionVM, translator, updateWizardData]);


    const onUpdateTerm = useCallback((termType) => {
        const allQuotesCopy = [...allQuotes];
        setTermTypeChanged(true);
        allQuotesCopy.map((quote) => {
            quote.termType_ML = termType.code;
            if (_.isUndefined(quote.quoteStatus)) {
                quote.quoteStatus = {
                    isStale: true
                };
            } else {
                quote.quoteStatus.isStale = true;
            }
            return quote;
        });
        setAllQuotes(allQuotesCopy);

        // Explicitly set isStale to true for selectedQuoteObj because actionButtonName is not updated if term is updated for 2nd time
        _.set(selectedQuoteObj, 'quoteStatus.isStale', true);
        setSelectedQuoteObj(selectedQuoteObj);
    }, [allQuotes, selectedQuoteObj]);

    const onAddVehicle = useCallback(() => {
        const data = {
            action: ADD_VEHICLE_ACTION
        };
        navigateToStep(PREFILL_STEP, data);
    }, [navigateToStep]);

    const onEditVehicle = useCallback(() => {
        navigateToStep(VEHICLES_STEP);
    }, [navigateToStep]);

    const onRemoveVehicle = useCallback((vehicle) => {
        const data = {
            action: REMOVE_VEHICLE_ACTION,
            model: vehicle
        };
        navigateToStep(PREFILL_STEP, data);
    }, [navigateToStep]);

    const setSuspendLiabilityWarning = useCallback(() => {
        clearBlockAlerts('suspendLiability');
        const currentCovs = getOfferingCoveragesFromBranchCodeAndName(selectedQuoteObj.branchCode, selectedQuoteObj.branchName);
        _.get(currentCovs, 'vehicleCoverages', []).forEach((vehicleCoverage) => {
            vehicleCoverage.coverages.forEach((coverage) => {
                if (coverage.name === 'Suspend Liability' && coverage.selected === true) {
                    addWarningAlert(messages.liabilityMessage, 'suspendLiability');
                }
            });
        });
    }, [getOfferingCoveragesFromBranchCodeAndName, selectedQuoteObj, addWarningAlert, clearBlockAlerts]);



    const shouldTestFunctionalReplacementCost = (details) => {
        return details && details.yearBuilt < 1986 && details.isReplacementCostSelected_ML !== undefined;
    };

    const updateFunctionalReplacementCostWarning = useCallback(() => {
        let showWarning = false;
        clearBlockAlerts('Functional Replacement Cost');

        if ((isHomeownersPolicy() || isLandlordHomePolicy()) && shouldTestFunctionalReplacementCost(_.get(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.value'))) {
            const isDwellingReplacementCostSelected = _.get(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.isReplacementCostSelected_ML');
            let isCoverageFunctionalReplacementCostSelected = false;

            const offeringCoverages = getOfferingCoveragesFromBranchCodeAndName(selectedQuoteObj.branchCode, selectedQuoteObj.branchName);
            if (selectedQuoteObj && offeringCoverages) {
                const baseCoverages = _.get(offeringCoverages, 'coverages.BaseCoverages', []);
                baseCoverages.forEach((basecoverage) => {
                    if (basecoverage.code_ML === 'HOPCovA') {
                        basecoverage.terms.forEach((hopcovaterm) => {
                            if ((hopcovaterm.codeIdentifier_ML === 'HOPCovAValuation') && (hopcovaterm.chosenTermValue === 'Functional Replacement Cost')) {
                                isCoverageFunctionalReplacementCostSelected = true;
                            }
                        });
                    }
                });
                showWarning = isDwellingReplacementCostSelected !== isCoverageFunctionalReplacementCostSelected;
            }
        }
        if (showWarning) {
            addWarningAlert(messages.buildingPropertyLossSettlement, 'Functional Replacement Cost')
            window.scrollTo(0, 0);
        }
    }, [addWarningAlert, clearBlockAlerts, getOfferingCoveragesFromBranchCodeAndName, isHomeownersPolicy, isLandlordHomePolicy, selectedQuoteObj, submissionVM]);

    const hasEffectiveDateChanged = useCallback(() => {
        const originalEffectiveDate = baseData.periodStartDate;
        const selectedQuoteEffectiveDate = selectedQuoteObj.periodStartDate;
        return !MLLocalDateUtil.isEqual(originalEffectiveDate, selectedQuoteEffectiveDate);
    }, [baseData, selectedQuoteObj]);

    const isQuotingInProgress = useCallback(() => {
        return (!hasQuotedAllPaymentPlans(selectedQuoteObj) && !isAK7DayPolicy()) || isQuoting;
    }, [hasQuotedAllPaymentPlans, isAK7DayPolicy, selectedQuoteObj, isQuoting]);

    const constructJsonQuoteObject = (quote) => {
        return {
            publicID: quote.publicID,
            monthlyPremium: quote.premium.monthlyPremium,
            total: quote.premium.total,
            branchCode: quote.branchCode
        };
    };

    const savePremiumforBundleQuoteAndGoToBundleCart = useCallback(() => {
        const offeredQuotes = submissionVM.quoteData.offeredQuotes.value;
        const jsonData = offeredQuotes.map((quote) => { return constructJsonQuoteObject(quote); });
        _.set(submissionVM, 'portalCurrentStep_ML.value', 'quoteDetails');
        showProgressDialog(platformMessages.saveSubmission);
        const selectOfferingPromise = LoadSaveService.selectOffering(submissionVM.value);
        selectOfferingPromise.then((savedSubmission) => {
            _.set(submissionVM, 'value', savedSubmission);
            MLPortalStorageService.store(submissionVM.quoteID.value, null, ML_STORAGE_KEY_PREVIOUS_PREMIUM, JSON.stringify(jsonData)).then(() => {
                removeScrollEventListener();
                history.push('/bundle-cart', {
                    accountNumber: submissionVM.baseData.accountNumber.value,
                    sessionUUID: submissionVM.sessionUUID.value,
                    quoteID: submissionVM.quoteID.value
                })
            });
        }, (error) => {
            setUwIssues(error);
        }).finally(() => {
            hideProgressDialog();
        });
    }, [hideProgressDialog, history, removeScrollEventListener, showProgressDialog, submissionVM]);

 const savePremiumAndGoToNext = useCallback(async () => {
        const offeredQuotes = submissionVM.quoteData.offeredQuotes.value;
        const jsonData = offeredQuotes.map((quote) => constructJsonQuoteObject(quote));
        _.set(submissionVM, 'portalCurrentStep_ML.value', 'quoteDetails');
        showProgressDialog(platformMessages.saveSubmission);
        try {
            const savedSubmission = await LoadSaveService.selectOffering(submissionVM.value);
            _.set(submissionVM, 'value', savedSubmission);
            await MLPortalStorageService.store(
                submissionVM.quoteID.value,
                null,
                ML_STORAGE_KEY_PREVIOUS_PREMIUM,
                JSON.stringify(jsonData)
            );
            const request = {
                jobNumber: submissionVM.quoteID.value,
                sessionUUID: submissionVM.sessionUUID.value,
                eventType: MLCustomHistoryTypes.QuoteAccepted
            };
            await MLHistoryService.createHistoryEvents([request]);
            removeScrollEventListener();
            // paMoreInfoFlowDispatcher
            if (!isQnB && isPersonalAuto() && savedSubmission.isConsumerCompRater() && MLMultiLobsDataHolderService.getFirstHVQConsumerNonCompletedStep()) {
                MLMultiLobsDataHolderService.storeFlowSteps('quoteDetails', 'paHVQConsumerPrefillAndCarfax');
                _.set(submissionVM, 'portalCurrentStep_ML.value', 'paHVQConsumerPrefillAndCarfax');
                showProgressDialog(platformMessages.saveSubmission);
                const res = await LoadSaveService.updateDraftSubmission(submissionVM.value);
                submissionVM.value = res;
                goNext();
            } else {
                const productCode = baseData?.productCode;
                const productSteps = stepNames?.[productCode];
 
                if (!productSteps || !Array.isArray(productSteps) || productSteps.length === 0) {
                    return;
                }
 
                const [nextStepName] = productSteps;
                if (!currentStep?.mlStepName || !nextStepName) {
                    return;
                }
 
                MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, nextStepName);
                const index = _.findIndex(
                    steps,
                    ({ path }) => path === '/additional-information-prebind'
                );
 
                let nextSteps = [];
                if (index >= 0) {
                    nextSteps = steps.slice(index);
                } else {
                    const additionalInfoPrebindIndex = _.findIndex(
                        wizardSteps, ({ path }) => path === '/additional-information-prebind'
                    );
 
                    if (additionalInfoPrebindIndex < 0) {
                        return;
                    }
                    nextSteps = _.slice(wizardSteps, additionalInfoPrebindIndex);
                }
                if (!nextSteps || nextSteps.length === 0) {
                    return;
                }
                changeNextSteps(nextSteps);
                goNext();
            }
        } catch (error) {
            setUwIssues(error);
        } finally {
            hideProgressDialog();
        }
    }, [submissionVM, showProgressDialog, removeScrollEventListener, isPersonalAuto, goNext, baseData.productCode, currentStep.mlStepName, steps, changeNextSteps, wizardSteps, hideProgressDialog]);

    // TODO : TA105643 : remove when PC rules are implemented
    const validatePANamedExclude = useCallback((callback) => {
        if (!(isPersonalAuto())) {
            return callback(true);
        }
        const currentCovs = getOfferingCoveragesFromBranchCodeAndName(selectedQuoteObj.branchCode, selectedQuoteObj.branchName);
        const vehicleCoverages = _.get(currentCovs, 'vehicleCoverages', []);
        // named non owner / no vehicle
        if (_.isEmpty(vehicleCoverages)) {
            return callback(true);
        }

        let isValid = true;
        vehicleCoverages.forEach((vehCov) => {
            const alertName = `paNamedExclude${vehCov.fixedId}`;
            clearBlockAlerts(alertName);
            const paNamedExcludeAllSelectedMessage = { ...messages.paNamedExcludeAllSelectedMessage, args: { vehicleName: vehCov.vehicleName } };
            const paNamedExcludeNoneSelectedMessage = { ...messages.paNamedExcludeNoneSelectedMessage, args: { vehicleName: vehCov.vehicleName } };
            const selectedNamedExcludeCov = vehCov.coverages.find((cov) => cov.code_ML === 'PAExcludeNamedDriverVehicleLevel_ML' && cov.selected);
            if (selectedNamedExcludeCov) {
                const drivers = selectedNamedExcludeCov.scheduledItems_ML.excludeNamedDrivers;
                const driversSelected = drivers.filter((d) => d.driverExcluded);
                if (driversSelected.length === 0) {
                    addErrorAlert(paNamedExcludeNoneSelectedMessage, alertName);
                    isValid = false;
                }
                if (driversSelected.length === drivers.length) {
                    addErrorAlert(paNamedExcludeAllSelectedMessage, alertName);
                    isValid = false;
                }
            }
        });
        return callback(isValid);
    }, [addErrorAlert, clearBlockAlerts, getOfferingCoveragesFromBranchCodeAndName, isPersonalAuto, selectedQuoteObj.branchCode, selectedQuoteObj.branchName]);

     const allowFlowWithoutSignalNumber = (submissionData) => {
            let drivers = submissionData?.lobData?.personalAuto?.coverables?.drivers;
            if (Array.isArray(drivers)) {
                const targetCodes = [
                    "PADriverSignalProgramPhoneNumber_Ext"
                ];
    
                drivers.forEach((driver) => {
                    const modifiers = driver?.driverModifiers_ML?.modifiers;
                    if (Array.isArray(modifiers)) {
                        modifiers.forEach((modifier) => {
                            if (modifier && targetCodes.includes(modifier.codeIdentifier_ML)) {
                                modifier.chosenTermValue = null;
                                modifier.isVisible_ML = false
                                modifier.isInputValueRequired_ML = false
                                modifier.editMode_ML = false
                                modifier.savedFromPortal = false
                            }
                        });
                    }
                });
            }
        }

    const shouldShowDriverExclusionAgreement = useCallback(() => {
            // show if state is OR and there are excluded drivers on submission and modal has not been displayed already
            const policyStateCode = submissionVM.baseData.policyAddress.state.value.code;
            const isStateOR = (state) => state === 'OR';
    
            const policyDrivers = _.get(submissionVM,"lobData.personalAuto.coverables.drivers.value",[]);
            const hasExcludedDrivers = policyDrivers.filter((d) => d.type_ML === 'excluded')?.length > 0;
    
            return isStateOR(policyStateCode) && hasExcludedDrivers;
        }, [submissionVM]);

         const requoteSubmission = useCallback(() => {
                allowFlowWithoutSignalNumber(submissionVM.value);
                const saveAndQuotePromise = LoadSaveService.saveAndQuoteSubmission(submissionVM.value);
                showProgressDialog(messages.calculatingQuote, saveAndQuotePromise);
                saveAndQuotePromise.then((qdd) => {
                    const newSubmissionVM = _.clone(submissionVM);
                    _.set(newSubmissionVM, 'value', qdd);
                    updateWizardData(newSubmissionVM);
                    setAllQuotes(initForQuotedData(qdd.quoteData));
                });
                return saveAndQuotePromise;
            }, [showProgressDialog, submissionVM, updateWizardData]);
        

     const showDriverExclusionAgreementModal = useCallback(() => {
            const disableButton = () => {
                return _.get(submissionVM,"lobData.personalAuto.excludedDriverScriptAgree_Ext.value") === undefined;
            };
    
            const onSaveAction = async (subVM) => {
                const agree = subVM.lobData.personalAuto?.excludedDriverScriptAgree_Ext.value;
                if (agree === true) {
                    // continue with excluded drivers
                    savePremiumAndGoToNext();
                } else {
                    // change excluded drivers to non drivers and requote
                    const policyDrivers = _.get(submissionVM,"lobData.personalAuto.coverables.drivers.value",[]);
                    const excludedDrivers = policyDrivers.filter((d) => d.type_ML === 'excluded');
                    excludedDrivers.forEach((driver) => {
                        driver.type_ML = 'nondriver';
                    });
    
                    showProgressDialog(messages.calculatingQuote);
                    try {
                        await requoteSubmission();
                    } catch (error) {
                        // do anything here?
                    } finally {
                        hideProgressDialog();
                    }
                }
            };
    
            const overrides = {
                descriptionText: {
                    content: translator(DriverExclusionAgreementPopupMessages.driverExclusionAgreementPopupContent, {
                            li: (chunks) => <li>{chunks}</li>,
                            ol: (chunks) => <ol>{chunks}</ol>,
                            ratedPremium: formatCurrency(intl, {
                                value: selectedQuoteObj.premium?.ratedLiabilityPremium_Ext?.amount,
                                currency: 'usd',
                                showFractions: false,
                                placeholder: '$0'
                            }),
                            excludedPremium: formatCurrency(intl, {
                                value: selectedQuoteObj.premium?.excludedLiabilityPremium_Ext?.amount,
                                currency: 'usd',
                                showFractions: false,
                                placeholder: '$0'
                            })
                        }
                    )
                },
                driverExclusionAgreementRadioButtons: {
                    availableValues: [
                        {
                            code: "true",
                            name: translator(DriverExclusionAgreementPopupMessages.radioButtonExcludedQnB)
                        },{
                            code: "false",
                            name: translator(DriverExclusionAgreementPopupMessages.radioButtonNondriverQnB)
                        }
                    ]
                }

            };
    
            const componentProps = {
                title: translator(DriverExclusionAgreementPopupMessages.driverExclusionAgreementPopupHeader),
                uiProps: DriverExclusionAgreementPopup.pageContent,
                actionBtnLabel: platformMessages.mlContinue,
                cancelBtnLabel: platformMessages.mlCancel,
                viewModel: submissionVM,
                disableButton,
                modalBodyStyles: DriverExclusionAgreementPopupStyles,
                overrideProps: overrides,
                onSaveAction,
                showXCloseButton: true
            }
    
            modalApi.showModal(
                <FormModalPopover {...componentProps} />
            ).then(() => {
                return true;
            }).catch(() => {
                return false;
            });
        }, [goNext, hideProgressDialog, modalApi, showProgressDialog, submissionVM, translator, updateWizardData]);

    const runMainButton = useCallback(() => {
        if (selectedQuoteObj
            && selectedQuoteObj.quoteStatus
            && selectedQuoteObj.quoteStatus.isStale) {
            setSuspendLiabilityWarning();
            updateFunctionalReplacementCostWarning();
            if (isCustomizableQuote(selectedQuoteObj) || hasEffectiveDateChanged() || termTypeChanged) {
                // TODO: TA105643: remove validation when PC Business Rule is completed
                validatePANamedExclude((isValid) => {
                    if (isValid) {
                        const updatePromises = [];
                        if (termTypeChanged) {
                            allQuotes.forEach((quote) => {
                                // Check if update uote exists and functions in custom quote
                                // $scope.$broadcast('UpdateQuoteStarted', { publicID: quote.publicID, branchName: quote.branchName });
                                if (!_.isUndefined(quote.updateQuote) && _.isFunction(quote.updateQuote)) {
                                    updatePromises.push(quote.updateQuote(submissionVM));
                                }
                            });
                        } else {
                            // $scope.$broadcast('UpdateQuoteStarted', { publicID: $scope.selectedQuote.publicID, branchName: $scope.selectedQuote.branchName });
                            updatePromises.push(selectedQuoteObj.updateQuote(submissionVM));
                        }
                        setIsQuoting(true);
                        Promise.all(updatePromises)
                            .then(() => {
                                setSuspendLiabilityWarning();
                            })
                            .finally(() => {
                                setIsQuoting(false);
                            });
                    } else {
                        window.scrollTo(0, 0);
                    }
                });
            } else {
                // $scope.$broadcast('UpdateQuoteStarted', { publicID: $scope.selectedQuote.publicID, branchName: $scope.selectedQuote.branchName });
                selectedQuoteObj.updateQuote(submissionVM).then(() => {
                    setSuspendLiabilityWarning();
                });
            }
        } else if (selectedQuoteObj) {
            _.set(submissionVM, 'quoteData.value.offeredQuotes', allQuotes);
            // TODO: TA105643: remove validation when PC Business Rule is completed
            if (shouldShowDriverExclusionAgreement()) {
                showDriverExclusionAgreementModal();
            } else {
            validatePANamedExclude((isValid) => {
                if (isValid) {
                    if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                        HOTrackEvent('Quote Step Submitted', false, submissionVM, null, { step: 'Quote Page', action: 'Quote Submitted' }, true);
                    } else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                        PUMBTrackEvent('Quote Step Submitted', false, submissionVM, null, { step: 'Quote Page', action: 'Quote Submitted' }, true);
                    } else {
                        PATrackEvent('Quote Step Submitted', false, submissionVM, null, { step: 'Quote Page', action: 'Quote Submitted' }, true);
                    }


                    if (isBundle) {
                        if (MLBundleService.inPostQuote()) {
                            MLBundleService.markJobsForPrequote();
                            MLBundleService.moveAllOtherJobsToReview(submissionVM.quoteID.value);
                        }
                        savePremiumforBundleQuoteAndGoToBundleCart();
                    } else {
                        savePremiumAndGoToNext();
                    }
                } else {
                    window.scrollTo(0, 0);
                }
            });
        }
        }
    }, [selectedQuoteObj, setSuspendLiabilityWarning, updateFunctionalReplacementCostWarning, isCustomizableQuote, hasEffectiveDateChanged, termTypeChanged, validatePANamedExclude, allQuotes, submissionVM, isBundle, savePremiumforBundleQuoteAndGoToBundleCart, savePremiumAndGoToNext]);

    const customQuotes = allQuotes.filter((quote) => {
        return quote.isCustom;
    });

    const setDefaultsCustomQuote = (cQuote) => {
        cQuote.selected = cQuote.isSlotted_ML;
        cQuote.offeringLevel = cQuote.branchName.substring(cQuote.branchName.lastIndexOf('(') + 1, cQuote.branchName.lastIndexOf(')'));
    };

    const getCustomQuotePopoverProps = useCallback((quotes, popupSelectedQuote) => {
        const customComponentResolvers = {
            customquoterangeslider: MLCustomQuoteRangeSliderComponent
        };

        const onSaveAction = () => {
            // default to selectedQuote if slider is not used to select a new base for custom quote
            setSelectedCustomQuote(popupSelectedQuote);
            return true;
        };

        const updateSelectedQuoteCallback = (newQuote) => {
            popupSelectedQuote = newQuote;
        };

        const overrides = {
            customQuoteRangeSlider: {
                quotes: quotes,
                selectedQuote: selectedQuoteObj,
                updateSelectedQuoteCallback: updateSelectedQuoteCallback
            }
        };

        const callbackMap = {
            onComparePlanClick: handleComparePlans
        }

        const componentProps = {
            title: translator(messages.coverageLevel),
            uiProps: CreateCustomQuotePopup.pageContent,
            viewModel: {},
            actionBtnLabel: messages.createCustomQuote,
            subtitle: isMobile() ? translator(messages.sliderSubtitleMobile) : translator(messages.sliderSubtitleDesktop),
            overrideProps: overrides,
            customComponentResolvers: customComponentResolvers,
            onSaveAction: onSaveAction,
            callbackMap
        };


        return componentProps;
    }, [selectedQuoteObj, translator, handleComparePlans]);

    const displayQuoteSliderModal = useCallback((allQuotesForSlider) => {
        const popupSelectedQuote = selectedQuoteObj;
        // For Landlord and Umbrella policy, only one offering, so shouldn't display the slider when creating custom quote
        if (allQuotesForSlider && allQuotesForSlider.length === 1) {
            setSelectedCustomQuote(allQuotesForSlider[0]);
        } else if (allQuotesForSlider && allQuotesForSlider.length > 1) {
            const componentProps = getCustomQuotePopoverProps(allQuotesForSlider, popupSelectedQuote);
            modalApi.showModal(
                <FormModalPopover {...componentProps} />
            );
        } else {
            showErrorModal(messages.errorCreatingOfferings, messages.errorCreatingOfferingsDesc);
        }
    }, [getCustomQuotePopoverProps, selectedQuoteObj, showErrorModal]);

    const addPreexistingQuoteAlert = () => {
        clearBlockAlerts('customQuoteAlreadyExists');
        addWarningAlert(messages.preexistingQuoteAlert, 'customQuoteAlreadyExists');
    };

    const deleteCustomQuotes = () => {
        if (customQuotes && customQuotes.length > 0) {
            // const deletePromise = CustomQuoteService.deletePeriodsFromSubmission('quoteandbind', customQuotes, $scope.sessionUUID, $scope.quoteID);
            // ModalService.showProgressDialog('quoteandbind.controllers.QuoteDetailsCtrl.Saving submission...', deletePromise);
        }
    };



    const isDeviceRemoved = () => {
        return !!_.get(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.isDeviceRemovedAlert_ML.value', false);
    };

    const setDeviceAlert = () => {
        if (isDeviceRemoved()) {
            addSuccessAlert(messages.deviceRemovedSuccessAlert, 'deviceRemoved');
        } else {
            clearBlockAlerts('deviceRemoved');
        }
    };

    const setAKAlerts = () => {
        if (isAK7DayPolicy()) {
            addWarningAlert(messages.ak7DayWarningAlert, 'ak7Day');
        } else if (isPersonalAuto() && _.get(baseData, 'policyAddress.state') === 'AK') {
            addWarningAlert(messages.akNot7DayWarningAlert, 'akNot7Day');
        }
    };


    const showVehicleDiscountAlert = (vehicle) => {
        let warningMsg = '';
        const alertName = 'vehicleConectedCarWarning_';
        switch (vehicle.carVTDEEligibilityStatus) {
            case 'not_eligible':
                warningMsg = messages.VTDENE;
                break;
            case 'invalid_vin':
                warningMsg = messages.VTDEIV;
                break;
            case 'eligible':
                warningMsg = messages.VTDEEL;
                break;
            case 'cancelled':
                warningMsg = messages.VTDECA;
                break;
            default:
                return;
        }
        warningMsg = { ...warningMsg, args: { vin: vehicle.vin } };
        addWarningAlert(warningMsg, alertName.concat(vehicle.vin));
    };



    useEffect(() => {
        setDeviceAlert();
        setAKAlerts();
        MLTagManagerService.sendFormStepEvent('QuoteInfo', 'QuoteInfo_QuotePremium');
        const bumpedPerils = _.get(submissionVM, 'perilBumpedCoverages_Ext.value', []);
        setPerilAlerts([bumpedPerils]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setPerilAlerts = useCallback(([warnings]) => {
        if (!_.isEmpty(warnings)) {
            if (warnings.includes("WindHail")) {
                addWarningAlert(messages.quoteWindstormHailDeductibleBumpedWarning, "windHail");
            }

            if (warnings.includes("MinRoofAge")) {
                addWarningAlert(messages.quoteRoofLossSettlementBumpedWarning, "roofLoss");
            }

            if (warnings.includes("AllOtherPeril")) {
                addWarningAlert(messages.quoteAllOtherPerilBumpedWarning, "allOtherPeril");
            }

            if (warnings.includes("GRCAvailable")) {
                addWarningAlert(messages.quoteGrcAvailableBumpedWarning, "grcAvailable");
            }
        }
    }, [addWarningAlert]);


    const resetToSlottedOfferingsOnly = (customQuotesParam) => {
        deleteCustomQuotes(customQuotesParam);
        const slottedOfferingQuotes = allQuotes.filter((quote) => quote.branchName !== CUSTOM_QUOTE);
        setAllQuotes(slottedOfferingQuotes);
    };

    const handleDuplicateCustomQuote = () => {
        const newCustomQuotes = allQuotes.filter((quote) => quote.branchName === CUSTOM_QUOTE);
        if (newCustomQuotes.length >= 1) {
            addPreexistingQuoteAlert();
            resetToSlottedOfferingsOnly(customQuotes);
        }
    };

    // Used to handle a custom quote being selected and saved on CustomQuotePopover
    useEffect(() => {
        if (!_.isEmpty(selectedCustomQuote)) {
            handleDuplicateCustomQuote();

            selectedCustomQuote.isSubmitAgent = false;
            const customQuoteDTO = {
                quote: selectedCustomQuote,
                sessionUUID: sessionUUID,
                quoteID: quoteID
            };
            const promise = CustomQuoteService.createCustomQuoteForOffering(customQuoteDTO);
            showProgressDialog(messages.quotingCustomQuote, promise);
            promise
                .then((quoted) => {
                    quoted.offeringCategory = CUSTOM_QUOTE;
                    const customQuotesNotSelected = createdCustomQuotes.filter((q) => q.publicID !== quoted.publicID).map((q) => q.publicID);
                    deleteCustomQuotes(customQuotesNotSelected);
                    const innerPromise = getCoveragesForQuoteIfNotPresent(quoted);
                    showProgressDialog(messages.quotingCustomQuote, innerPromise);
                    innerPromise.then(() => {
                        setDefaultsCustomQuote(quoted);
                        const allQuotesCopy = [...allQuotes];
                        const indexOfCustomQuote = allQuotesCopy.findIndex((q) => q.branchName === CUSTOM_QUOTE);
                        if (indexOfCustomQuote === -1) {
                            allQuotesCopy.push(quoted);
                        } else {
                            allQuotesCopy[indexOfCustomQuote] = quoted;
                        }
                        quoteForAllOtherPayments(quoted);
                        allQuotesCopy.forEach((quote) => {
                            quote.showLoading = false;
                        });
                        setAllQuotes(allQuotesCopy);
                        setSelectedQuoteAndUpdateTabs(quoted, allQuotesCopy);
                    });
                })
                .finally(() => setSelectedCustomQuote({}));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCustomQuote]);

    const initForSliderQuotedData = useCallback(() => {
        return quoteData.offeredQuotes.filter((quote) => {
            return !quote.isCustom;
        });
    }, [quoteData.offeredQuotes]);

    const createCustomQuote = useCallback(() => {
        const otherOfferingsPromise = CustomQuoteService.getQuotesForOtherOfferings(sessionUUID, quoteID);
        showProgressDialog(messages.creatingOfferings, otherOfferingsPromise)
        otherOfferingsPromise.then((offerings) => {
            submissionVM.quoteData.offeredQuotes.value.push(...offerings);
        }).catch((e) => {
            console.log(e);
        }).finally(() => {
            window.scrollTo(0, 0);
            const allQuotesForSlider = isQnB ? initForQuotedData() : initForSliderQuotedData();
            displayQuoteSliderModal(allQuotesForSlider);
        });
    }, [showProgressDialog, CustomQuoteService, displayQuoteSliderModal, initForSliderQuotedData, quoteID, sessionUUID, submissionVM]);


    const getFooterPremium = useCallback(() => {
        if (isAK7DayPolicy()) {
            const premium = _.get(selectedQuoteObj, 'total.amount', 0);
            const currency = _.get(selectedQuoteObj, 'total.currency', 'usd');
            return translator(messages.amountPer7Days,
                { premium: intl.formatNumber(premium, { style: 'currency', currency: currency }) });
        }

        const premium = _.get(selectedQuoteObj, 'premium.monthlyPremium.amount', 0);
        const currency = _.get(selectedQuoteObj, 'premium.monthlyPremium.currency', 'usd');
        return translator(messages.amountPerMonth,
            { premium: intl.formatNumber(premium, { style: 'currency', currency: currency }) });
    }, [isAK7DayPolicy, translator, intl, selectedQuoteObj]);

    const getOfferingOverrides = useCallback(() => {
        const offeringOverrides = allQuotes.map((quote, index) => {
            // console.log(quote, index)
            // const isCustomQuote = index === allQuotes.length - 1
            sessionStorage.setItem("isCustom", quote?.isCustom.toString())
            return {
                [`${OFFERING_TAB_ID_STRING}${index}`]: { heading: getTabHeader(quote) },
                [`noGridSpace${index}`]: {
                    className : (isQnB && quote?.isCustom) ? 'noGridSpace ' : 'noGridSpace'
                },
                [`initialMessage${index}`]: { content: quote.status },
                [`plansDiv${index}`]: {
                    // Hide plan comparison plann due to business request.
                    // visible: !isBundle && (isPersonalAuto() || isHomeowners())
                    visible: false
                },
                [`aboutCoverageTitle${index}`]: {
                    content: !(isQnB && isModernProduct) && translator(messages.aboutCoverageTitle,
                        { offeringName: formatBranchName(quote.branchName) }),
                    className : (isQnB && quote?.isCustom) ? 'padding-top-40 vertical-spacing-10 section-header covStyle' : 'padding-top-40 vertical-spacing-10 section-header headerTwo'
                },
                [`aboutCoverageMessage${index}`]: { 
                    content: getOfferingMessage(quote.branchName, quote.branchCode),
                    className : (isQnB && quote?.isCustom) ? 'body-copy light vertical-spacing-40 covMsgStyle' : 'body-copy vertical-spacing-40 '
                },                [`quoteSummaryBar${index}`]: {
                    quote: getQuoteVm(quote),
                    getFullPayPlan: getFullPayPlanForOffering,
                    recurringPlanPeriod: getRecurringPlanPeriod(quote),
                    autoTermTypeList: autoTermTypeList,
                    onUpdateTerm: onUpdateTerm,
                    onPrint: handlePrint,
                    onEmail: handleEmail,
                    runMainButton: runMainButton,
                    mainButtonName: actionButtonName,
                    updateEffDate: onUpdateEffDate,
                    isBundle: isBundle,
                    isQuotingInProgress: isQuotingInProgress(),
                    productCode,
                    isPersonalAuto: isPersonalAuto(),
                    // TODO: determine if this is the only case where bar is read only
                    isReadOnly: isAK7DayPolicy(),
                    isQnB,
                    className: styles.datePickerWidth
                },
                [`customCoverageButton${index}`]: {
                    className: isQnB ? "vertical-spacing-0 secondaryButton widthSmall" : "vertical-spacing-0 mobileButton",
                    content: isQnB ? convertToSentenceCase(translator(messages.createCustomQuoteBtn)) : translator(messages.createCustomQuoteBtn)
                },
                [`quoteSummaryBarBottom${index}`]: {
                    quote: getQuoteVm(quote),
                    getFullPayPlan: getFullPayPlanForOffering,
                    runMainButton: runMainButton,
                    recurringPlanPeriod: getRecurringPlanPeriod(quote),
                    autoTermTypeList: autoTermTypeList,
                    onUpdateTerm: onUpdateTerm,
                    onPrint: handlePrint,
                    onEmail: handleEmail,
                    mainButtonName: actionButtonName,
                    isPersonalAuto: isPersonalAuto(),
                    isBundle: isBundle,
                    isQuotingInProgress: isQuotingInProgress(),
                    isReadOnly: isAK7DayPolicy(),
                    isQnB
                },
                [`customQuoteComponent${index}`]: {
                    submissionVM: submissionVM,
                    customQuote: quote,
                    isAgent: false,
                    isDisplayOnly: !isCustomizableQuote(quote),
                    addVehicle: onAddVehicle,
                    editVehicle: onEditVehicle,
                    removeVehicle: onRemoveVehicle,
                    editCoverage: createCustomQuote,
                    baseData: _.get(submissionVM, 'baseData', {}),
                    hideEditLinks: (submissionVM.value.isConsumerCompRater() && !!MLMultiLobsDataHolderService.getFirstHVQConsumerNonCompletedStep()) || isAK7DayPolicy(),
                    hideEditCoverage: isAK7DayPolicy(),
                    updateWizardData: updateWizardData,
                    lobPath: lobPathString,
                    isBundle,
                    refreshSelectedQuoteObj,
                    navigateToStep,
                    viewModelService
                },
                [`customQuoteDiv${index}`]: {
                    visible: !isCustomizableQuote(quote) && !isAK7DayPolicy()
                },
                [`includedFeaturesComponent${index}`]: {
                    model: getIndexedOfferingCoveragesVM(index),
                    showTooltip: true
                },
                [`quotePageDriversComp${index}`]: {
                    visible: isPersonalAuto(),
                    submissionVM,
                    navigateToStep,
                    isAK7DayPolicy,
                    isGateway: false
                }
            };
        });

        return Object.assign({}, ...offeringOverrides);
    }, [allQuotes, getTabHeader, isBundle, isPersonalAuto, isHomeowners, translator, formatBranchName, getOfferingMessage, getQuoteVm, getFullPayPlanForOffering, getRecurringPlanPeriod, autoTermTypeList, onUpdateTerm, handlePrint, handleEmail, runMainButton, actionButtonName, onUpdateEffDate, isQuotingInProgress, productCode, submissionVM, isCustomizableQuote, onAddVehicle, onEditVehicle, onRemoveVehicle, createCustomQuote, isAK7DayPolicy, updateWizardData, lobPathString, refreshSelectedQuoteObj, navigateToStep, getIndexedOfferingCoveragesVM]);

    useEffect(() => {
        if (isQuotingInProgress() && isQuoting) {
            setActionButtonName(translator(messages.requoting));
            setIsQuoteChanged(true);
        } else if (selectedQuoteObj && _.get(selectedQuoteObj, 'quoteStatus.isStale', false)) {
            setActionButtonName(translator(messages.requote));
            setIsQuoteChanged(true);
        } else if (isBundle) {
            setActionButtonName(translator(messages.continue));
            setIsQuoteChanged(false);
        } else {
            setActionButtonName(isQnB ? convertToSentenceCase(translator(messages.continueToPurchase)) : translator(messages.continueToPurchase));
            setIsQuoteChanged(false);
        }
    }, [isBundle, isQuotingInProgress, selectedQuoteObj, allQuotes, translator, submissionVM.value, isQuoting]);

    const generateOverrides = useCallback(() => {
        return {
            '@field': {
                // apply to all fields
                labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
            },
            startDate: {
                visible: showQuoteStartDate
            },
            print: {
                visible: !showQuoteStartDate
            },
            subHeader: {
                content: (
                    <FormattedMessage
                        {...messages.quoteSubHeader}
                        values={{
                            quoteNum: (
                                <strong>
                                    {`#${quoteID}`}
                                </strong>
                            )
                        }}
                    />
                ),
                className: !isHomeowners() || isRentPolicy() ? 'body-copy vertical-spacing-40' : 'body-copy'
            },
            hoReplacementCostHeader: {
                visible: isHomeowners()
            },
            hoReplacementCostHeaderMsg: {
                content: getReplacementCostMsg()
            },
            hoReplacementCostHeaderTooltip: {
                tooltipContent: getReplacementCostTooltip()
            },
            offeringsTabs: {
                data: allQuotes,
                defaultActiveTab: `${OFFERING_TAB_ID_STRING}${selectedQuoteIndex}offeringsTabs`,
                activeTab: activeTab,
                className: isMobile() ? `${styles.parentTabset} ${styles.mobileView}` : styles.parentTabset
            },
            subsectionHeader: {
                className: _.get(selectedQuoteObj, 'quoteStatus.isStale', false) ? 'subsection-header premium-strike' : 'subsection-header',
                content: getFooterPremium()
            },
            stateFeesComponent: {
                visible: _.get(selectedQuoteObj, 'totalChanges_Ext.amount', undefined) !== undefined,
                totalFees: _.get(selectedQuoteObj, 'totalChanges_Ext', {}),
                itemizedFees: _.get(selectedQuoteObj, 'feesCosts_Ext', {}),
                displayAlternativeTemplate: true
            },
            changesMadeP: {
                visible: isQuoteChanged
            },
            stickyFooterMainButton: {
                content: actionButtonName,
                disabled: isQnB ? (isQuotingInProgress() && isQuoting) || isAK7DayPolicy() : isQuotingInProgress() || isAK7DayPolicy(),
                className: (isQnB) ? 'runMainButton mobileButton primaryButton' : 'runMainButton mobileButton'
            },
            customCoverageButton: {
                className: isQnB ? 'vertical-spacing-0 secondaryButton' : 'vertical-spacing-0 mobileButton',
                content: isQnB ?  convertToSentenceCase(translator(messages.createCustomQuote)) : translator(messages.createCustomQuote)
            },
            mobileDropdown: {
                availableValues: getQuoteDropdownAvailableValues(),
                value: selectedQuoteIndex,
                onValueChange: onQuoteDropdownChange,
                visible: isMobile()
            },
            currentPremiumP: {
                className: isQnB ? "font-uppercase padding-bottom-0 gwLayout0 text-primary-color" : "font-uppercase padding-bottom-0 gwLayout0"
            },
            quoteDetailsContainer: {
                className: (isQnB) ? 'ml-quote-details quoteDetailsStyle' : 'ml-quote-details'
            },
            ...getOfferingOverrides()
        };
    }, [breakpoint, showQuoteStartDate, quoteID, isHomeowners, isRentPolicy, getReplacementCostMsg, getReplacementCostTooltip, allQuotes, selectedQuoteIndex, activeTab, selectedQuoteObj, getFooterPremium, isQuoteChanged, actionButtonName, isQuotingInProgress, getQuoteDropdownAvailableValues, onQuoteDropdownChange, getOfferingOverrides]);


    registerScrollEventListener();

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            quotePageDriverTablesComponent: QuotePageDriverTablesComponent,
            privacyPolicyComponent: PrivacyPolicyComponent
        },
        resolveCallbackMap: {
            onPrint: handlePrint,
            onComparePlanClick: handleComparePlans,
            onQuoteTabChange: onQuoteTabChange,
            onClickCustomQuote: createCustomQuote,
            onRunMainButton: runMainButton
        }
    };

    return (
        <WizardPage showNext={false} showPrevious={false} showCancel={false} skipWhen={skipOnResumeIf} hidePrivacyPolicy={true}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={generateOverrides()}
                onModelChange={updateWizardData}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                onValidationChange={onValidate}
            />
        </WizardPage>
    );
}

QuotePage.propTypes = wizardProps;
export default withRouter(QuotePage);
